var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 6.09639H8.33337C5.57195 6.09639 3.33337 8.33497 3.33337 11.0964C3.33337 13.8578 5.57195 16.0964 8.33337 16.0964H16.6667M16.6667 6.09639L13.3334 2.76306M16.6667 6.09639L13.3334 9.42973",
    stroke: "#667185",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/event-icon.71f96b2f17b7f9451b31ff40deb6161c.svg";
export { ForwardRef as ReactComponent };